<template>
<div class="kt-portlet__foot">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>